<script>
  import { onMount } from 'svelte';
  import { SPRITES } from "../../constants/sprites";
  import ActionButtons from "../components/ActionButtons.svelte";
  import Component from "../components/Component.svelte";
  import ComponentTiled from "../components/ComponentTiled.svelte";
  import CraftingTable from "../components/CraftingTable/CraftingTable.svelte";
  import Rotation from "../components/Debug/Rotation.svelte";
  import MonsterBoard from "../components/MonsterBoard.svelte";
  import PlayerBoard from "../components/Playerboard/PlayerBoard.svelte";
  import SpinNumber from "../components/SpinNumber.svelte";
  import TurnOrder from "../components/TurnOrder.svelte";
  import AlchemistTop3Cards from "../components/AlchemistTop3Cards.svelte";
  import ItemsToPlaceOrRemove from "../components/ItemsToPlaceOrRemove.svelte";
  import {
    SetupStore,
    PlayerId,
    PlayerOrder,
    GameStateStore,
    IsTurn,
    ItemsStore,
    DecideStore,
    GameStatesStore,
    Hearts,
    MerchantClicked,
    PlayersStore,
    RemoveStore,
    ItemsToPlace,
    CurrentBattleLog,
    SwitchMonster,
    SelectedActions,
    PotionsStore,
    PotionsDiscardPile,
  } from "../stores/gameStore";
  import BattleScreen from "./BattleScreen.svelte";
  import MerchantToken from "../components/MerchantToken.svelte";
  import PotionCard from "../components/PotionCard.svelte";

  $: playerBoards = $SetupStore?.playerboards;
  $: boardId = playerBoards?.[$PlayerId]?.board_ID;
  $: allPlayerIDs = Object.values($PlayersStore).map(player => player.id);
  $: playerOrder = allPlayerIDs.filter((p) => p !== $PlayerId);
  $: heartsAmount = $Hearts[$PlayerId];
  $: merchantClicked = $MerchantClicked;

  //Check Switch Monster
  $: switchMonsterItems = $SwitchMonster.unusedItems || {};
  $: playerCards = [
      ...Object.values($ItemsStore).filter((c) => c.card_location == $PlayerId),
    ];
  let switchMonsterButton = false;  
  let switchMonsterPossible = false;
  let switchMonsterChosenItem = false;
  $: if ($GameStateStore?.name === 'startFight' && $SelectedActions[0].action != ("ACTION_KING") && $SelectedActions[0].action != ("ACTION_ROGUE_04")) {
      switchMonsterButton = false; 
      switchMonsterPossible = false;
      switchMonsterChosenItem = false;
      Object.keys(playerCards).forEach(item => {
        if (Object.keys(switchMonsterItems).includes(String(playerCards[item].id))) {
          switchMonsterButton = true; 
          if (switchMonsterItems[playerCards[item].id] == true) {
            switchMonsterPossible = true;
            switchMonsterChosenItem = playerCards[item].id;
          }
        }
      });
    } else {
      switchMonsterButton = false; 
      switchMonsterPossible = false;
      switchMonsterChosenItem = false;
    }

  let craftingTreeHeight = 0;
  let craftingTableWidth = 1523;
  $: if (Object.keys($PlayersStore).length === 3) {
    craftingTableWidth = 1333;
  }
  $: if (Object.keys($PlayersStore).length === 2) {
    craftingTableWidth = 1143;
  }

  let viewCraftingTableWidth = 0;
  let viewCraftingTableHeight = 0;
  let ppButtonPosition = "right: 46px; top: 462px;";
  let ppTooltipPosition = "right: 50px; top: -30px;";
  $: if (craftingTableFlip === false) {
    viewCraftingTableWidth = craftingTableWidth; // Normal width
    viewCraftingTableHeight = 510; // Normal height
    ppButtonPosition = "right: 46px; top: 462px;";
    ppTooltipPosition = "right: 50px; top: -30px;";
    if (morePotions === false) {
      ppTooltipPosition = "right: 50px; top: 300px;";
    }
  } else {
    viewCraftingTableWidth = 510; // Flipped width
    viewCraftingTableHeight = craftingTableWidth; // Flipped height
    ppButtonPosition = "right: 50px; top: 15px;";
    ppTooltipPosition = "right: -50px; top: 50px;";
  }

  let gameScreenElement; // Reference to the GameScreen element
  let containerWidth = 0;
  let containerHeight = 0;
  let craftingTableFlip = false;
  let battleScreenSmall = false;

  // Dynamically check if crafting table exceeds the screen width
  const checkLayout = () => {
    const parentElement = gameScreenElement.parentElement;
    containerWidth = parentElement.offsetWidth;
    containerHeight = parentElement.offsetHeight;
    
    craftingTableFlip = craftingTableWidth > containerWidth;
    battleScreenSmall = 950 > containerWidth;
  };

  onMount(() => {
    // Set up window resize listener
    window.addEventListener('resize', checkLayout);

    // Initial check on mount
    checkLayout();

    return () => {
      window.removeEventListener('resize', checkLayout);
    };
  });

  let hiddenFightscreen = false;
  $:if ($GameStateStore?.name === 'startFight') {
    hiddenFightscreen = false;
  }
  let gameFinished = false;
  $: if ($CurrentBattleLog?.enemy?.class == 4 && $CurrentBattleLog?.result == 'WIN') {
    gameFinished = true;
  }

  $: showBattleScreen =
    $CurrentBattleLog &&
    ($GameStateStore?.name === "fight" || gameFinished === true) &&
    hiddenFightscreen === false;

  let passButtonName = _('Pass');
  $:if ($GameStateStore?.name === 'endTurn') {
    passButtonName = _('End Turn');
  } else {
    passButtonName = _('Pass');
  }

  // Handle Potions Pile Info

  let showTooltip = false; // Controls the visibility of the tooltip
  let hideTimeout;

  function handleMouseEnter() {
    clearTimeout(hideTimeout);
    showTooltip = true;
  }
  
  function handleMouseLeave() {
    hideTimeout = setTimeout(() => {
      showTooltip = false;
    }, 500); // Wait 500ms before hiding
  }
  
  function handleTooltipEnter() {
    clearTimeout(hideTimeout); // Cancel hiding when hovering over the tooltip
  }
  
  function handleTooltipLeave() {
    hideTimeout = setTimeout(() => {
      showTooltip = false;
    }, 500); // Wait 500ms before hiding
  }
  
  function handleOnClick() {
    if (showTooltip == true) {
      showTooltip = false;
      return;
    }
    showTooltip = true;
  }


  let cardScale = 0.6;
  $: discardPile = Array.isArray($PotionsDiscardPile)
      ? $PotionsDiscardPile
      : Object.values($PotionsDiscardPile);
  $: potionsPile = Object.entries($SetupStore.data.cards)
                    .filter(([id, card]) => card.type === 'POTION' && !discardPile.includes(id) && id != 'facedown')
                    .map(([id]) => id);
  $: potionPositions = Object.fromEntries(
                        Object.values($PotionsStore)
                          .filter(entry => entry.id !== "facedown")
                          .map(entry => [entry.id, entry.card_location])
                      );

  let morePotions = false;
  function clickMorePotions() {
    if (morePotions === false) {
      morePotions = true;
      return;
    }
    if (morePotions === true) {
      morePotions = false;
      return;
    }
  }


  //Texts for Translations

  const textStartFight = _('Start Fight');
  const textCraftItem = _('Craft Item');
  const textheart = _('heart');
  const texthearts = _('hearts');
  const textHideFighscreen = _('Hide Fightscreen');
  const textShowFighscreen = _('Show Fightscreen');
  const textSwitch = _('Switch Creature');
  const textPotionsPile = _('Potion discard pile');
  const textOtherPotions = _('Other potions (in potion pile or in players inventories)');
  const textMorePotions = _('Show all potions');
  const textLessPotions = _('Hide other potions');
</script>

<!-- <pre>{JSON.stringify(potionPositions, null, 2)}</pre> -->

<div class="wrapper"
bind:this={gameScreenElement}
>
  <div
  class="actions whiteblock"
  class:stacked={craftingTableFlip}
  style="width: {viewCraftingTableWidth - 34}px; min-height: 74px"
  >
    {#if ($GameStateStore?.name === "actionSelection" ||
         $GameStateStore?.name === "potionSelectNewAction")
         && allPlayerIDs.includes($PlayerId)}
      <ActionButtons stacked={craftingTableFlip}/>
    {/if}

    {#if $GameStateStore?.name === "fight" || gameFinished === true}
      <button
        class="btn"
        on:click={() => {
          hiddenFightscreen === false
          ? hiddenFightscreen = true
          : hiddenFightscreen = false
        }}>{
          hiddenFightscreen === false
          ? textHideFighscreen
          : textShowFighscreen
          }</button
      >
    {/if}

    {#if $IsTurn}
      {#if $GameStateStore?.possibleactions?.includes("startFight")}
        <button
          class="btn"
          on:click={() => {
            window.GAME.bgaPerformAction("startFight");
          }}>{textStartFight}</button
        >
      {/if}
      {#if switchMonsterButton}
        <button
          class="btn"
          class:disabled={!switchMonsterPossible}
          on:click={() => {
            window.GAME.bgaPerformAction("switchMonster", {
                        cardId: switchMonsterChosenItem,
                        playerId: $PlayerId,
                      });
          }}>{textSwitch}</button
        >
      {/if}

      {#if $GameStateStore?.possibleactions?.includes("decideCraftMaterial")}
        <button
          class="btn"
          disabled={$DecideStore?.selected?.length != 2}
          on:click={() => {
            window.GAME.bgaPerformAction("decideCraftMaterial", {
              material1: $DecideStore.selected[0],
              material2: $DecideStore.selected[1],
              playerId: $PlayerId,
            });
          }}>{textCraftItem}</button
        >
      {/if}

      {#if $GameStateStore?.possibleactions?.includes("pass")}
        <button
          class="btn"
          on:click={() => {
            window.GAME.bgaPerformAction("pass");
          }}>{passButtonName}</button
        >
      {/if}

      {#if $GameStateStore?.possibleactions?.includes("alchemistSkillHearts")}
          {#each Array(heartsAmount).fill(0).map((_, i) => i + 1) as heartNumber}
            <button
              class="btn"
              on:click={() => {
                window.GAME.bgaPerformAction("alchemistSkillHearts", {
                  heartAmount: heartNumber,
                });
              }}>{heartNumber} {heartNumber > 1 ? texthearts : textheart}</button
            >
          {/each} 
      {/if}

      {#if $GameStateStore?.possibleactions?.includes("alchemistSkillViewPile")}
          <AlchemistTop3Cards
          width={500}
          />
      {/if}

      {#if $GameStateStore?.possibleactions?.includes("selectPlayerToDamage")}
        {#each playerOrder as playerId}
          <button
            class="btn"
            on:click={() => {
              window.GAME.bgaPerformAction("selectPlayerToDamage", {
                playerId: playerId,
              });
            }}
            style="color: #{$PlayersStore[playerId]?.color}; outline-color: black;"
          >
            {$PlayersStore[playerId]?.name}
          </button>
        {/each}  
      {/if}

      {#if $GameStateStore?.name === "makeSpace"}
        <ItemsToPlaceOrRemove />
      {/if}

    {/if}

    {#if craftingTableFlip === false}
      <div style:flex={1}/>
      <TurnOrder stacked={craftingTableFlip}/>
    {/if}

  </div>

  {#if craftingTableFlip === true}
    <div
    class="actions stacked whiteblock"
    style="width: {viewCraftingTableWidth - 34}px; min-height: 74px"
    >
      <TurnOrder stacked={craftingTableFlip}/>
    </div>
  {/if}


  <div class="top" class:stacked={craftingTableFlip || !allPlayerIDs.includes($PlayerId)}>
    {#if allPlayerIDs.includes($PlayerId)}
      <PlayerBoard {boardId} width={500} playerId={$PlayerId} ownBoard {craftingTableFlip} />
    {/if}
    <MonsterBoard />
  </div>

  <div class="crafting-tree-container" style="height: {`${viewCraftingTableHeight}px`}; width: {`${viewCraftingTableWidth}px`};">

    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->

    <div class="dijitTooltipContainer tooltip" 
    class:visible={showTooltip}
    style= {ppTooltipPosition}
    on:mouseenter={handleMouseEnter}
    on:mouseleave={handleMouseLeave}
    >
      <div style="display:flex; flex-direction:column; max-width: 550px; word-wrap: break-word; margin: 20px">
          <div class="headline">
            {textPotionsPile}
          </div>
          <hr style="width:100%;"/>
          <div style="display:flex; flex-direction:row; flex-wrap:wrap; gap:10px;">
            {#each discardPile as card}
                <PotionCard
                width={SPRITES["ITEMS_FRONT"].width * cardScale * 0.5}
                card={$SetupStore.data.cards[card]}
                active= 0
                id={card}
                />
            {/each}
          </div>
          <hr style="width:100%;"/>
          {#if morePotions}
            <div class="headline">
              {textOtherPotions}
            </div>
            <hr style="width:100%;"/>
            <div style="display:flex; flex-direction:row; flex-wrap:wrap; gap:10px;">
              {#each potionsPile as card}
                <div class="card-container">
                    <PotionCard
                    width={SPRITES["ITEMS_FRONT"].width * cardScale * 0.5}
                    card={$SetupStore.data.cards[card]}
                    active= 0
                    id={card}
                    />
                    {#if potionPositions[card]}
                      <p 
                        class="player-name-potions" 
                        style="color: #{$PlayersStore[potionPositions[card]]?.color};"
                      >
                        {$PlayersStore[potionPositions[card]]?.name}
                      </p>
                    {/if}
                </div>
              {/each}
            </div>
            <button
              class="btn"
              on:click={() => {
                morePotions = false;
              }}>{textLessPotions}</button
            >
          {/if}
          {#if !morePotions}
          <button
            class="btn"
            on:click={() => {
              morePotions = true;
            }}>{textMorePotions}</button
          >
          {/if}
      </div>
    </div>
    <div
    style="position:absolute; z-index: 15; {ppButtonPosition}"
    >
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <!-- svelte-ignore a11y-no-static-element-interactions -->
      <div
        class= "potions_pile_discard"
        on:mouseenter={handleMouseEnter}
        on:mouseleave={handleMouseLeave}
        on:click={handleOnClick}
      >
        <Component
          width={32}
          sprite={{
            width: 180,
            height: 180,
            class: "TOKENS",
          }}
          fullWidth={SPRITES.TOKENS.fullWidth}
          offset={[560, 300]}
          borderRadius={1}
        />
      </div>
    </div>
    <div class="crafting-table"
        class:flipped={craftingTableFlip}>
      <CraftingTable scale={0.6} flipped={craftingTableFlip} />
    </div>
  </div>

  <div class="bottom" class:stacked={craftingTableFlip}>
    {#each playerOrder as playerId}
      <div
        style="display: flex; flex-direction: column; align-items: center; justify-content: center; "
      >
          <p 
            class="player-name" 
            style="color: #{$PlayersStore[playerId]?.color};"
          >
            {$PlayersStore[playerId]?.name}
          </p>
          <PlayerBoard
            boardId={playerBoards[playerId].board_ID}
            width={487}
            {playerId}
          />
      </div>
    {/each}
  </div>

</div>

{#if showBattleScreen}
    <BattleScreen
    battleScreenSmall = {battleScreenSmall}
    />
{/if}

<style>
  .wrapper {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: center;
  }

  .actions {
    padding: 0.5rem 1rem;
    border-radius: 10px;
    gap: 0.5rem;
    margin: 0;
    display: flex;
    justify-content: space-evenly;
  }

  .actions.stacked {
    justify-content: center;
  }
  .top {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
  }

  /* Stack the PlayerBoard and MonsterBoard vertically if needed */
  .top.stacked {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }

  .crafting-tree-container {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /* Crafting Table */
  .crafting-table {
    display: flex;
    justify-content: center;
  }

  /* Flip the crafting table if its width exceeds the screen size */
  .crafting-table.flipped {
    transform: rotate(-90deg);
    transform-origin: center center;
  }

  .potions_pile_discard {
      position:absolute;
      /* background: rgba(255, 0, 0, 0.2); */
      border-radius: 1.5rem;
      outline: solid;
      outline-color: black;
      outline-width: 1.5px;
    }
  
  .potions_pile_discard:hover {
      filter: brightness(1.2);
    }

  .tooltip {
      position: absolute;
      padding: 10px;
      border-radius: 5px;
      z-index: 250;
      display: none;
      pointer-events: none;
    }
  
  .tooltip.visible {
      display: block;
      pointer-events: auto; /* Allow clicks on visible cards */
      gap: 10px; /* Optional: add some space between the cards */
    }

  .card-container {
    position: relative;
    display: inline-block;
  }

  .player-name-potions {
    position: absolute;
    top: 2px;
    font-size: 10px;
    width: 73px;
    font-weight: bold;
    text-align: center;
    margin: 0;
    color: inherit; /* Use the inline style for dynamic colors */
    background-color: rgba(255, 255, 255, 0.95);
    opacity: 1; /* Ensure full opacity */
    padding: 2px 5px;
    border-radius: 10px;
    display: inline-block;
    pointer-events: none;
    white-space: nowrap; /* Prevent text wrapping */
    overflow: hidden; /* Hide overflow text */
    text-overflow: ellipsis; /* Add "..." for overflow text */
  }
  .bottom {
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 1rem;
  }

  .bottom.stacked {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }

  .player-name {
    font-weight: bold;
    text-align: center;
    margin: 0;
    color: inherit; /* Use the inline style for dynamic colors */
    background-color: rgba(255, 255, 255, 0.6);
    padding: 2px 5px;
    border-radius: 5px;
    display: inline-block;
  }

  .disabled {
    opacity: 0.4;
    pointer-events: none;
  }
</style>
